import React from 'react';

import { ReactComponent } from '../../assets/svg/list_alt.svg';


export default () => <ReactComponent />;
